import React from "react";
import Card from "~/components/parts/Card";

const Links = ({ collections, enrichment }) => (
  <div className="m-0 xl:ml-2">
    <Card className="m-0 mb-4 xl:mb-3 border-[#e61d83]" title="Collections">
      <div className="flex flex-col gap-2.5">
        {collections.map(({ href, label, onClick }, i) => (
          <div key={`collection-${i + 1}`}>
            <a
              href={href}
              className="text-sm text-slate-600 transition hover:text-slate-900"
              onClick={onClick}
            >
              {label}
            </a>
          </div>
        ))}
      </div>
    </Card>
    <Card className="m-0 border-[#ffff00]" title="Enrichment">
      <div className="flex flex-col gap-2.5">
        {enrichment.map(({ href, label, onClick }, i) => (
          <div key={`enrichment-${i + 1}`}>
            <a
              href={href}
              className="text-sm text-slate-600 transition hover:text-slate-900"
              onClick={onClick}
            >
              {label}
            </a>
          </div>
        ))}
      </div>
    </Card>
  </div>
);

export default Links;
